import { extractComponentName } from "composables/useHelpers";
import type { Component } from "vue";

type ComponentEntry = {
  name: string;
  component: Component;
};

export const components: ComponentEntry[] = Object.entries(
  import.meta.glob<Component>("./**/*.vue", {
    import: "default",
    eager: true,
  }),
).reduce<ComponentEntry[]>((result, [path, component]) => {
  const componentName = extractComponentName(path);

  if (componentName === null) {
    return result;
  }

  result.push({
    name: componentName,
    component,
  });

  return result;
}, []);

export default components;
